import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProducerLoginForm from './producer-login-form';
import { EventIdVerification } from '../../../services/event/eventid-verification';
import Loader from '../../../utils/loader/loader';
import { EventData } from '../../../interfaces/producer-login';



const ProducerLoginView = () => {
    const { eventId } = useParams();
    const [responseStatus, setResponseStatus] = useState<number | null>(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [eventData, setEventData] = useState<EventData | undefined>(undefined);
    const navigate = useNavigate()

    useEffect(() => {
        const verifyEventId = async () => {
            try {
                const response = await EventIdVerification(eventId || '');
                if (response.status === 200) {
                    setResponseStatus(response.status);
                    setEventData(response.data.data); 
                } else {
                    setResponseStatus(response.status);
                    setErrorMessage('Invalid Event ID');
                }
            } catch (error) {
                console.error('Error verifying event ID:', error);
                setResponseStatus(null);
                setErrorMessage('Error verifying event ID');
                navigate(`/404}`)
            } finally {
                setIsLoading(false);
            }
        };

        verifyEventId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId]);

    return (
        <div>
            {isLoading ? (
                <Loader />
            ) : (
                responseStatus === 200 && eventData ? (
                    <ProducerLoginForm eventData={eventData} />
                ) : (
                    <div>{errorMessage}</div>
                )
            )}
        </div>
    );
};

export default ProducerLoginView;
